// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"725":"d49520aa","755":"91c1bf5d"}[chunkId] + ".js";
};